import Swiper from 'swiper';
import { computed, reactive } from 'vue';

import { SubscriptionFeature } from '@/components/subscription-promo-modal/helpers/subscription-promo-helper/type/type';
import { getUniqNumber } from '@/helpers/number';

import adsSvg from '../../../../assets/img/ads.svg?url';
import boostSvg from '../../../../assets/img/boost.svg?url';
import diamondSvg from '../../../../assets/img/diamond.svg?url';
import eyeSvg from '../../../../assets/img/eye.svg?url';
import heartSvg from '../../../../assets/img/heart.svg?url';
import premSvg from '../../../../assets/img/prem.svg?url';
import searchSvg from '../../../../assets/img/search.svg?url';
import unlimSvg from '../../../../assets/img/unlim.svg?url';

type UseSelfArg = {
  feature?: SubscriptionFeature;
};

export function useSelf(arg: UseSelfArg) {
  // Ref -----------------------------------------------------------------------
  const id = getUniqNumber();

  // Hook ----------------------------------------------------------------------

  // Computed ------------------------------------------------------------------
  const slideList = computed(() => {
    const list = [
      {
        feature: SubscriptionFeature.ADVANCED_INFORMATION,
        sub: 'sub1',
        text: 'text1',
        img: premSvg,
      },
      {
        feature: SubscriptionFeature.UNLIMITED_LIKES,
        sub: 'sub2',
        text: 'text2',
        img: heartSvg,
      },
      {
        feature: SubscriptionFeature.ADVANCED_SEARCH,
        sub: 'sub3',
        text: 'text3',
        img: searchSvg,
      },
      {
        feature: SubscriptionFeature.UNLIMITED_MESSAGES,
        sub: 'sub4',
        text: 'text4',
        img: unlimSvg,
      },
      {
        feature: SubscriptionFeature.SEE_WHO_LIKES_YOU,
        sub: 'sub5',
        text: 'text5',
        img: eyeSvg,
      },
      {
        feature: SubscriptionFeature.BOOST_PROFILE,
        sub: 'sub6',
        text: 'text6',
        img: boostSvg,
      },
      {
        feature: SubscriptionFeature.ADS,
        sub: 'sub7',
        text: 'text7',
        img: adsSvg,
      },
      {
        feature: SubscriptionFeature.PREMIUM_FILTERS,
        sub: 'premiumFiltersTitle',
        text: 'premiumFiltersDescription',
        img: diamondSvg,
      },
    ];

    return list;
  });

  const slideInitialIndex = computed(() => {
    const featureIndex = slideList.value.findIndex((item) => item.feature === arg.feature);
    const featureMessageIndex = slideList.value.findIndex(
      (item) => item.feature === SubscriptionFeature.UNLIMITED_MESSAGES,
    );

    return featureIndex === -1 ? featureMessageIndex : featureIndex;
  });

  // Method --------------------------------------------------------------------
  function initSwiper() {
    new Swiper(`.swiper-gallery-container${id}`, {
      loop: false,
      initialSlide: slideInitialIndex.value,
      pagination: {
        el: `.swiper-gallery-pagination${id}`,
        type: 'bullets',
        clickable: true,
        bulletClass: 'bullet',
        bulletActiveClass: 'active',
        renderBullet(index, className) {
          return `<div class="h-1.5 w-1.5 bg-white opacity-40 rounded-full ${className}"></div>`;
        },
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
    });
  }

  async function init() {
    initSwiper();
  }

  return reactive({
    id,
    slideList,
    init,
  });
}
